module.exports = __webpack_public_path__ + "img/1-9.2619e62c.png";